var map = {
	"./contura-logo.svg": 38,
	"./icons/add-plus.svg": 39,
	"./icons/arrow-down-orange.svg": 40,
	"./icons/bar-chart-statistics.svg": 41,
	"./icons/bookmark-o.svg": 42,
	"./icons/bookmark.svg": 43,
	"./icons/calculator.svg": 44,
	"./icons/chat.svg": 45,
	"./icons/close.svg": 46,
	"./icons/cog.svg": 47,
	"./icons/comments-o.svg": 48,
	"./icons/credit-card.svg": 49,
	"./icons/delivery-cart.svg": 50,
	"./icons/download.svg": 51,
	"./icons/file-image-o.svg": 52,
	"./icons/file-upload.svg": 53,
	"./icons/flame.svg": 54,
	"./icons/home-2.svg": 55,
	"./icons/home.svg": 56,
	"./icons/password.svg": 57,
	"./icons/picture-image.svg": 58,
	"./icons/plus-circle.svg": 59,
	"./icons/plus.svg": 60,
	"./icons/search.svg": 61,
	"./icons/sign-out.svg": 62,
	"./icons/symbol-defs.svg": 63,
	"./icons/user-circle-o.svg": 64,
	"./icons/user-settings.svg": 65,
	"./icons/user.svg": 66,
	"./placeholder-brochure.png": 67,
	"./placeholder-chart.jpg": 68,
	"./placeholder-product.png": 69,
	"./placeholder-video.jpg": 70,
	"./placeholder.jpg": 71,
	"./running-dog.gif": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;